<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="dedication"></a><a id="page_v"><span class="txit">For America’s diplomats and development experts, who represent our country and our values so well in places large and small, peaceful and perilous all over the world.</span></a></p><a id="page_v">
<p class="ded1">and</p>
<p class="deda"><span class="txit">In memory of my parents:</span></p>
<p class="deda"><span class="txit">Hugh Ellsworth Rodham (1911–1993)</span></p>
</a><p class="deda"><a id="page_v"><span class="txit">Dorothy Emma Howell Rodham (1919–2011)</span></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?64e46e0c